import { ALink } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

import rebrandedSealImage from "../../../../images/rebranded/seal.svg"

const MoneyBack = ({ className }) => {
  return (
    <div
      sx={{
        mt: [6, 0],
        p: 4,
        display: "flex",
        alignItems: "center",
        gap: 4,
        fontSize: 3,
        bg: "lightYellow",
        borderRadius: "8px",
      }}
      className={className}
    >
      <img
        src={rebrandedSealImage}
        alt=""
        sx={{ width: 70, objectFit: "contain" }}
      />

      <div>
        <Trans i18nKey="ChoosePlan.MoneyBack.title" />{" "}
        <ALink
          isTextColor
          isUnderlined
          href="https://support.formelskin.de/hc/de/articles/360022115719-Gibt-es-eine-Geld-zur%C3%BCck-Garantie-und-wie-funktioniert-sie-
"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ fontSize: 1 }}
        >
          <Trans i18nKey="ChoosePlan.MoneyBack.readMore" />{" "}
        </ALink>
      </div>
    </div>
  )
}

export default MoneyBack
